// Shared types for @minne/core. These shapes are the contract in CLAUDE.md ("Content model").
export class PatchError extends Error {
    code;
    opIndex;
    blockId;
    constructor(code, message, extra = {}) {
        super(message);
        this.name = "PatchError";
        this.code = code;
        this.opIndex = extra.opIndex;
        this.blockId = extra.blockId;
    }
}
export const ID_PATTERN = /^[a-z][a-z0-9_-]{0,31}$/;
export function isValidId(id) {
    return ID_PATTERN.test(id);
}
//# sourceMappingURL=types.js.map